import swal from 'sweetalert2'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRotate, faShare, faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import { Button, Form } from '@domain-group/suit-theme'

import { generateApplicationUrl } from '@domain-group/javascript-utils'

import { confirmDelete } from '@functions/entity'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import useCampaign from '@hooks/useCampaign'
import type { UseCampaignPayload } from '@hooks/useCampaign'
import type { UseCampaignContactPayload } from '@hooks/useCampaignContact'

import type { CampaignModel, UserModel } from '@models/types'

type ShareLinkParams = {
  campaign: CampaignModel,
  shareMobileLink: (payload: HandleCallbackActionParams) => void,
  shareFn: UseCampaignPayload['callbacks']['shareMobileLink'],
  user: UserModel,
}

const confirmShareLink = (params: ShareLinkParams) => {
  const {
    campaign, shareFn, shareMobileLink, user,
  } = params

  // @ts-expect-error TS2339
  const { applicationUrl } = generateApplicationUrl({
    applicationKey: 'realhub',
    // @ts-expect-error TS2322
    environment: process.env.REACT_APP_APPLICATION_ENV,
  })

  const shareParams = {
    activity_key: 'campaign.shared_with_user',
    message: '',
    redirect_url: `${applicationUrl}/#/campaigns/${campaign.id}/edit`,
    recipients: [{ user_id: user.id, mobile: user.mobile_number }],
  }

  const shareLinkPayload = {
    callbacks: {
      action: shareFn,
    },
    entityParams: shareParams,
    toastText: 'SMS Sent',
  }

  swal.fire({
    confirmButtonColor: '#43ac6a',
    confirmButtonText: 'Yes, send it.',
    icon: 'success',
    reverseButtons: true,
    showCancelButton: true,
    text: "Are you sure? This campaign share link will be sent via SMS to the user's mobile.",
    title: 'Share Link?',
  }).then(({ value }) => {
    if (value){
      // @ts-expect-error TS2345
      shareMobileLink(shareLinkPayload)
    }
  })
}

interface OptionsProps {
  callbacks: {
    closeModal: () => void,
    deleteFn: UseCampaignContactPayload['callbacks']['deleteCampaignContact'],
    resetDefaultState: () => void,
    shareMobileLink: (payload: HandleCallbackActionParams) => void,
  },
  campaign: CampaignModel,
  isNewRecord: boolean,
  user: UserModel,
}

const Options = (props: OptionsProps) => {
  const {
    callbacks: {
      closeModal, deleteFn, resetDefaultState, shareMobileLink,
    },
    campaign,
    isNewRecord,
    user,
  } = props

  const {
    callbacks: { shareMobileLink: shareFn },
  } = useCampaign(campaign)

  const confirmDeletePayload = {
    callbacks: {
      afterAction: closeModal,
      deleteFn,
    },
    strings: {
      entityName: 'Contact',
      deleteString: 'remove',
    },
  }

  return (
    <Form.Field label="More Options" marginTop="large">
      {isNewRecord && (
        <Button
          buttonStyle="secondaryUtility"
          onClick={() => resetDefaultState()}
          icon={<FontAwesomeIcon icon={faRotate} />}
          size="medium"
        >
          Reset Fields
        </Button>
      )}

      {user?.id && (
        <Button
          buttonStyle="secondaryUtility"
          onClick={() => confirmShareLink({
            campaign, shareFn, shareMobileLink, user,
          })}
          icon={<FontAwesomeIcon icon={faShare} />}
          size="medium"
        >
          Share Link
        </Button>
      )}

      {!isNewRecord && (
        <Button
          buttonStyle="secondaryUtility"
          // @ts-expect-error TS2345
          onClick={() => confirmDelete(confirmDeletePayload)}
          icon={<FontAwesomeIcon icon={faTrashAlt} />}
          marginTop={user?.id ? 'medium' : null}
          size="medium"
        >
          Remove Contact
        </Button>
      )}
    </Form.Field>
  )
}

export default Options
